import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ChatLogBooking, PaginatedChatLogBookingsData, ChatType } from '../../types/chat_booking';
import { chatBookingEndpoints } from '../../services/api/endpoints/chat_bookings.endpoints';
import { RootState } from '..';

export const fetchAllChatBookings = createAsyncThunk(
  'chatBooking/fetchAll',
  async ({
    orgId,
    page = 1,
    pageSize = 10,
    chatType,
    isVoice,
  }: {
    orgId: string;
    page?: number;
    pageSize?: number;
    chatType?: ChatType | null;
    isVoice?: boolean;
  }) => {
    console.log('Hook 3');
    const res = await chatBookingEndpoints.getChatLogBookings(
      orgId,
      page,
      pageSize,
      chatType,
      isVoice
    );
    console.log('Hook 4');
    return res as PaginatedChatLogBookingsData;
  }
);

export const fetchBetweenDates = createAsyncThunk(
  'chatBooking/fetchBetweenDates',
  async ({
    orgId,
    startDate,
    endDate,
    page = 1,
    pageSize = 10,
    chatType,
  }: {
    orgId: string;
    startDate: string;
    endDate: string;
    page?: number;
    pageSize?: number;
    chatType?: ChatType | null;
  }) => {
    const res = await chatBookingEndpoints.getChatLogBookingsBetweenDates(
      orgId,
      startDate,
      endDate,
      page,
      pageSize,
      chatType
    );
    return res as PaginatedChatLogBookingsData;
  }
);

interface ChatBookingState {
  chatLogs: ChatLogBooking[];
  unreadCount: number;
  isLoading: boolean;
  error: string | null;
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

const initialState: ChatBookingState = {
  chatLogs: [],
  unreadCount: 0,
  isLoading: false,
  error: null,
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

const chatBookingSlice = createSlice({
  name: 'chatBooking',
  initialState,
  reducers: {
    markAsViewed: () => {
      // no local work – we’ll refetch instead
    },
    reset: () => initialState,
  },
  extraReducers: builder =>
    builder

      .addCase(fetchAllChatBookings.pending, s => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(fetchAllChatBookings.fulfilled, (s, a) => {
        console.log('Hook 1');
        s.isLoading = false;
        s.chatLogs = a.payload?.chatLogs ?? [];
        s.unreadCount = a.payload?.unreadCount ?? 0;
        s.page = a.payload?.page ?? 1;
        s.pageSize = a.payload?.pageSize ?? 10;
        s.total = a.payload?.total ?? 0;
        s.totalPages = a.payload?.totalPages ?? 0;
      })
      .addCase(fetchAllChatBookings.rejected, (s, a) => {
        s.isLoading = false;
        s.error = a.error.message || 'Unknown';
      })

      .addCase(fetchBetweenDates.pending, s => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(fetchBetweenDates.fulfilled, (s, a) => {
        console.log('Hook 1');
        s.isLoading = false;
        s.chatLogs = a.payload?.chatLogs ?? [];
        s.unreadCount = a.payload?.unreadCount ?? 0;
        s.page = a.payload?.page ?? 1;
        s.pageSize = a.payload?.pageSize ?? 10;
        s.total = a.payload?.total ?? 0;
        s.totalPages = a.payload?.totalPages ?? 0;
      })
      .addCase(fetchBetweenDates.rejected, (s, a) => {
        s.isLoading = false;
        s.error = a.error.message || 'Unknown';
      }),
});

export const { markAsViewed, reset } = chatBookingSlice.actions;
export default chatBookingSlice.reducer;

export const selectChatBooking = (state: RootState) => state.chatBookingLogs;
